import http from "./http"
import {Toast} from "vant";

// 每次会话只加载一次系统参数，故需要查询新系统参数时请维护这个数组
const keys = [
    'miniProgramHomeUrl',  // 小程序首页地址
    'mobile_servicehall_tab_config',  // 服务大厅Tab显示配置
    'allServiceOrMy', // 服务大厅默认显示 1全部服务||2与我相关||3不显示按钮
    'MOBILE_SEND_TO_ME', // 附件发送给我按钮是否显示
    'MOBILE_PAGE_TITLE', // 移动端页面标题
    'onlineProcessingRibbon',//是否在线办理显示飘带
    'floatRemind',//是否无权限显示飘带
    'blisuseParam',//“服务中心”是否显示“服务方式”查询条件
    'portal_mode',//门户类型
]

/**
 * 查询系统参数，会缓存在sessionStorage，本次会话不再重复查询
 * 每次会话只加载一次系统参数，故需要查询新系统参数时请维护这个数组
 * @param variableKey
 * @returns {Promise<string|*>}
 */
export const sysVariable = async variableKey => {
    const storageKey = 'sys-variable'

    // 尝试从缓存获取
    const storage = sessionStorage.getItem(storageKey);
    const local = storage!=="undefined" && storage!==""?JSON.parse(storage):null;
    if (local && local[variableKey]) return local[variableKey]
    // 从接口获取
    http.get('/nonlogin/param/keys.htm', {keys: keys.join()}).then(resp=>{
        if (!resp || resp.code != 200) Toast(`获取系统参数${variableKey}失败`)
        sessionStorage.setItem(storageKey, JSON.stringify(resp.data))
        return resp.data[variableKey]
    });

}